import { render, staticRenderFns } from "./index.vue?vue&type=template&id=64298328&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64298328')) {
      api.createRecord('64298328', component.options)
    } else {
      api.reload('64298328', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=64298328&", function () {
      api.rerender('64298328', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/audit/brand/index.vue"
export default component.exports